import React from 'react';
import SwitchCustom from 'components/SwitchCustom';
import styled from 'styled-components';

type Props = {
  value?: boolean;
  onChange?: (value: boolean) => void;
};

const SwitchBookingOnline = ({ value, onChange }: Props) => {
  const onClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    onChange?.(!value);
  };

  return (
    <Container onClick={onClick}>
      <SwitchCustom title='Booking online' checked={value} />
      <div className='booking-online-text'>Booking online</div>
    </Container>
  );
};

export default SwitchBookingOnline;

const Container = styled.div`
  cursor: pointer;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  .booking-online-text {
    user-select: none;
    color: #505050;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;
